import type { EmployeeCompetency } from '@/types/manager-assessment/Competency';

export interface CompetencyGroup {
    groupName: string;
    competencies: EmployeeCompetency[];
}

/**
 * Groups competencies by their groupName, preserving first-seen order. Competencies with no group
 * fall back to `ungroupedLabel`.
 */
export const groupCompetenciesByName = (
    competencies: EmployeeCompetency[],
    ungroupedLabel = '',
): CompetencyGroup[] => {
    const order: string[] = [];
    const byName = new Map<string, EmployeeCompetency[]>();

    competencies.forEach((competency) => {
        const groupName = competency.groupName ?? ungroupedLabel;
        if (!byName.has(groupName)) {
            byName.set(groupName, []);
            order.push(groupName);
        }
        byName.get(groupName)?.push(competency);
    });

    return order.map((groupName) => ({ groupName, competencies: byName.get(groupName) ?? [] }));
};
